// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__pe-m-","emails":"CreateEditClinics_emails__3Qbr-","emailTagLabel":"CreateEditClinics_emailTagLabel__3CN4w"};